import { getTransformedMarkers } from "@locators/components/PrizeLocator/utils/index";

import type { FlotiqApi } from "@jti/rest-api";

export const getUpdatedLocation = async (storeId: string, flotiqApi: FlotiqApi) => {
  const response = await flotiqApi.getStoreByExternalId(storeId);
  const markers = getTransformedMarkers(response.data);
  return { markers, storeId };
};
